<template>
  <Breadcrumb
    :id="0"
    :name="nameLabel"
    :type="$tc('models.network', 1) | capitalize"
    :showBackButton="showBackButton"
    @backButtonPressed="clickBack"
  >
    <template v-slot:icon>
      <MapIcon v-bind="networkIcon" :size="39"/>
    </template>
  </Breadcrumb>
</template>

<script>
import { mapGetters } from 'vuex';

import Breadcrumb from '@/components/Layout/Breadcrumb.vue';
import NetworkIcon from '@/enums/NetworkIcon';

import MapIcon from '../../../components/Map/MapIcon.vue';

export default {
  name: 'BreadcrumbSelection',
  components: { Breadcrumb, MapIcon },
  props: {
    showBackButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    customBackAction: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      networkIcon: NetworkIcon,
    };
  },
  computed: {
    ...mapGetters({
      network: 'settings/getNetworkModel',
    }),
    nameLabel() {
      return this.network ? this.network.name : '';
    },
  },
  methods: {
    clickBack() {
      if (this.customBackAction) {
        this.$emit('backButtonPressed');
      }
    },
  },
};
</script>
